module.exports = __webpack_public_path__ + "media/shared/images/apple-touch-icon-ipad-00db636d2352e29d2d5bf06b099bf579.png";